import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { trackEvent } from '../../../services/trackingService.js';

import SuggestDiscount from '../../resolution/suggestDiscount.jsx';
import { suggestDiscount } from '../payment/paymentActions.js';
import Page from '../../page.jsx';
import { data as agreementDataPropTypes } from '../../agreementPropTypes.js';
import partnerPropTypes from '../../partnerPropTypes.js';
import paymentPropTypes from '../../paymentPropTypes.js';
import safeTradePropTypes from '../../safeTradePropTypes.js';
import { role as rolePropType } from '../../userPropTypes.js';

class SuggestDiscountPage extends PureComponent {
    constructor() {
        super();
        this.handleClickSendSuggestion = this.handleClickSendSuggestion.bind(
            this
        );
    }

    componentDidMount() {
        trackEvent(
            'trade.buyer-does-not-approve-item.seller-opens-suggest-other-discount-form'
        );
    }

    handleClickSendSuggestion({ discount }) {
        const { partner, safeTrade } = this.props;

        this.props.dispatch(
            suggestDiscount({
                itemId: safeTrade.itemId,
                itemType: safeTrade.itemType,
                partnerId: partner.id,
                discount,
            })
        );
    }

    render() {
        const { agreement, partner, payment, safeTrade, role } = this.props;

        return (
            <Page heading="Foreslå et passende prisavslag">
                <SuggestDiscount
                    agreement={agreement}
                    cancelLink="/losning/foresla-losning"
                    enableConfirm={!payment.loading}
                    feePercentage={safeTrade.feePercentage}
                    onConfirm={this.handleClickSendSuggestion}
                    partner={partner}
                    role={role}
                />
            </Page>
        );
    }
}

SuggestDiscountPage.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    dispatch: PropTypes.func.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
    safeTrade: safeTradePropTypes.isRequired,
    role: rolePropType.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        partner: state.partner,
        payment: state.payment,
        safeTrade: state.safeTrade,
        role: state.user.role,
    };
}

export default connect(mapStateToProps)(SuggestDiscountPage);



// WEBPACK FOOTER //
// ./safeTrade/seller/resolution/suggestDiscountPage.jsx